module.exports = __webpack_public_path__ + "static/media/report.bcb882bf.svg";